import * as i0 from '@angular/core';
import { Injectable } from '@angular/core';
import * as i1 from '@angular/common/http';
import { HttpHeaders } from '@angular/common/http';
import { map } from 'rxjs/operators';

// *********************************
// Code generated by sdkgen
// DO NOT EDIT!.
//
// Enums.
// *********************************
var EventType = /*#__PURE__*/function (EventType) {
  EventType[EventType["EVENT_TYPE_UNSPECIFIED"] = 0] = "EVENT_TYPE_UNSPECIFIED";
  EventType[EventType["EVENT_TYPE_TYPING_STARTED"] = 1] = "EVENT_TYPE_TYPING_STARTED";
  EventType[EventType["EVENT_TYPE_TYPING_STOPPED"] = 2] = "EVENT_TYPE_TYPING_STOPPED";
  EventType[EventType["EVENT_TYPE_REPRESENTATIVE_JOINED"] = 3] = "EVENT_TYPE_REPRESENTATIVE_JOINED";
  EventType[EventType["EVENT_TYPE_REPRESENTATIVE_LEFT"] = 4] = "EVENT_TYPE_REPRESENTATIVE_LEFT";
  return EventType;
}(EventType || {});
var MessageType = /*#__PURE__*/function (MessageType) {
  MessageType[MessageType["MESSAGE_TYPE_UNSPECIFIED"] = 0] = "MESSAGE_TYPE_UNSPECIFIED";
  MessageType[MessageType["MESSAGE_TYPE_TEXT"] = 1] = "MESSAGE_TYPE_TEXT";
  MessageType[MessageType["MESSAGE_TYPE_IMAGE"] = 2] = "MESSAGE_TYPE_IMAGE";
  return MessageType;
}(MessageType || {});
var UserType = /*#__PURE__*/function (UserType) {
  UserType[UserType["USER_TYPE_UNSPECIFIED"] = 0] = "USER_TYPE_UNSPECIFIED";
  UserType[UserType["USER_TYPE_BOT"] = 1] = "USER_TYPE_BOT";
  UserType[UserType["USER_TYPE_HUMAN"] = 2] = "USER_TYPE_HUMAN";
  return UserType;
}(UserType || {});
// *********************************
// Code generated by sdkgen
// DO NOT EDIT!.
//
// Enums.
// *********************************
var MetricType = /*#__PURE__*/function (MetricType) {
  MetricType[MetricType["NONE"] = 0] = "NONE";
  MetricType[MetricType["QUERIES_DIRECT"] = 1] = "QUERIES_DIRECT";
  MetricType[MetricType["QUERIES_INDIRECT"] = 2] = "QUERIES_INDIRECT";
  MetricType[MetricType["VIEWS_MAPS"] = 3] = "VIEWS_MAPS";
  MetricType[MetricType["VIEWS_SEARCH"] = 4] = "VIEWS_SEARCH";
  MetricType[MetricType["ACTIONS_WEBSITE"] = 5] = "ACTIONS_WEBSITE";
  MetricType[MetricType["ACTIONS_PHONE"] = 6] = "ACTIONS_PHONE";
  MetricType[MetricType["ACTIONS_DRIVING_DIRECTIONS"] = 7] = "ACTIONS_DRIVING_DIRECTIONS";
  MetricType[MetricType["QUERIES_CHAIN"] = 8] = "QUERIES_CHAIN";
  MetricType[MetricType["PHOTOS_VIEWS_MERCHANT"] = 9] = "PHOTOS_VIEWS_MERCHANT";
  MetricType[MetricType["PHOTOS_VIEWS_CUSTOMERS"] = 10] = "PHOTOS_VIEWS_CUSTOMERS";
  MetricType[MetricType["PHOTOS_COUNT_MERCHANT"] = 11] = "PHOTOS_COUNT_MERCHANT";
  MetricType[MetricType["PHOTOS_COUNT_CUSTOMERS"] = 12] = "PHOTOS_COUNT_CUSTOMERS";
  MetricType[MetricType["LOCAL_POST_VIEWS_SEARCH"] = 13] = "LOCAL_POST_VIEWS_SEARCH";
  MetricType[MetricType["LOCAL_POST_ACTIONS_CALL_TO_ACTION"] = 14] = "LOCAL_POST_ACTIONS_CALL_TO_ACTION";
  return MetricType;
}(MetricType || {});
var Period = /*#__PURE__*/function (Period) {
  Period[Period["DAY"] = 0] = "DAY";
  Period[Period["WEEK"] = 1] = "WEEK";
  Period[Period["MONTH"] = 2] = "MONTH";
  return Period;
}(Period || {});
// *********************************
// Code generated by sdkgen
// DO NOT EDIT!.
//
// Enums Index.
// *********************************

function enumStringToValue$8(enumRef, value) {
  if (typeof value === 'number') {
    return value;
  }
  return enumRef[value];
}
class FieldMask {
  static fromProto(proto) {
    let m = new FieldMask();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.paths !== 'undefined') {
      toReturn['paths'] = this.paths;
    }
    return toReturn;
  }
}
function enumStringToValue$7(enumRef, value) {
  if (typeof value === 'number') {
    return value;
  }
  return enumRef[value];
}
class GoogleDate {
  static fromProto(proto) {
    let m = new GoogleDate();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.year !== 'undefined') {
      toReturn['year'] = this.year;
    }
    if (typeof this.month !== 'undefined') {
      toReturn['month'] = this.month;
    }
    if (typeof this.day !== 'undefined') {
      toReturn['day'] = this.day;
    }
    return toReturn;
  }
}
function enumStringToValue$6(enumRef, value) {
  if (typeof value === 'number') {
    return value;
  }
  return enumRef[value];
}
class PostInsightsHistory {
  static fromProto(proto) {
    let m = new PostInsightsHistory();
    m = Object.assign(m, proto);
    if (proto.views) {
      m.views = parseInt(proto.views, 10);
    }
    if (proto.callToActionClicks) {
      m.callToActionClicks = parseInt(proto.callToActionClicks, 10);
    }
    if (proto.postedDateTime) {
      m.postedDateTime = new Date(proto.postedDateTime);
    }
    if (proto.statsDateTime) {
      m.statsDateTime = new Date(proto.statsDateTime);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.socialProfileId !== 'undefined') {
      toReturn['socialProfileId'] = this.socialProfileId;
    }
    if (typeof this.internalPostId !== 'undefined') {
      toReturn['internalPostId'] = this.internalPostId;
    }
    if (typeof this.views !== 'undefined') {
      toReturn['views'] = this.views;
    }
    if (typeof this.callToActionClicks !== 'undefined') {
      toReturn['callToActionClicks'] = this.callToActionClicks;
    }
    if (typeof this.postedDateTime !== 'undefined' && this.postedDateTime !== null) {
      toReturn['postedDateTime'] = 'toApiJson' in this.postedDateTime ? this.postedDateTime.toApiJson() : this.postedDateTime;
    }
    if (typeof this.statsDateTime !== 'undefined' && this.statsDateTime !== null) {
      toReturn['statsDateTime'] = 'toApiJson' in this.statsDateTime ? this.statsDateTime.toApiJson() : this.statsDateTime;
    }
    if (typeof this.partnerId !== 'undefined') {
      toReturn['partnerId'] = this.partnerId;
    }
    if (typeof this.accountGroupId !== 'undefined') {
      toReturn['accountGroupId'] = this.accountGroupId;
    }
    return toReturn;
  }
}
function enumStringToValue$5(enumRef, value) {
  if (typeof value === 'number') {
    return value;
  }
  return enumRef[value];
}
class Answer {
  static fromProto(proto) {
    let m = new Answer();
    m = Object.assign(m, proto);
    if (proto.upVoteCount) {
      m.upVoteCount = parseInt(proto.upVoteCount, 10);
    }
    if (proto.published) {
      m.published = new Date(proto.published);
    }
    if (proto.created) {
      m.created = new Date(proto.created);
    }
    if (proto.modified) {
      m.modified = new Date(proto.modified);
    }
    if (proto.previousVersions) {
      m.previousVersions = proto.previousVersions.map(Answer.fromProto);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.partnerId !== 'undefined') {
      toReturn['partnerId'] = this.partnerId;
    }
    if (typeof this.accountGroupId !== 'undefined') {
      toReturn['accountGroupId'] = this.accountGroupId;
    }
    if (typeof this.locationId !== 'undefined') {
      toReturn['locationId'] = this.locationId;
    }
    if (typeof this.questionId !== 'undefined') {
      toReturn['questionId'] = this.questionId;
    }
    if (typeof this.version !== 'undefined') {
      toReturn['version'] = this.version;
    }
    if (typeof this.locationPathName !== 'undefined') {
      toReturn['locationPathName'] = this.locationPathName;
    }
    if (typeof this.text !== 'undefined') {
      toReturn['text'] = this.text;
    }
    if (typeof this.author !== 'undefined') {
      toReturn['author'] = this.author;
    }
    if (typeof this.authorPhotoUrl !== 'undefined') {
      toReturn['authorPhotoUrl'] = this.authorPhotoUrl;
    }
    if (typeof this.authorType !== 'undefined') {
      toReturn['authorType'] = this.authorType;
    }
    if (typeof this.answerId !== 'undefined') {
      toReturn['answerId'] = this.answerId;
    }
    if (typeof this.upVoteCount !== 'undefined') {
      toReturn['upVoteCount'] = this.upVoteCount;
    }
    if (typeof this.published !== 'undefined' && this.published !== null) {
      toReturn['published'] = 'toApiJson' in this.published ? this.published.toApiJson() : this.published;
    }
    if (typeof this.created !== 'undefined' && this.created !== null) {
      toReturn['created'] = 'toApiJson' in this.created ? this.created.toApiJson() : this.created;
    }
    if (typeof this.modified !== 'undefined' && this.modified !== null) {
      toReturn['modified'] = 'toApiJson' in this.modified ? this.modified.toApiJson() : this.modified;
    }
    if (typeof this.previousVersions !== 'undefined' && this.previousVersions !== null) {
      toReturn['previousVersions'] = 'toApiJson' in this.previousVersions ? this.previousVersions.toApiJson() : this.previousVersions;
    }
    return toReturn;
  }
}
function enumStringToValue$4(enumRef, value) {
  if (typeof value === 'number') {
    return value;
  }
  return enumRef[value];
}
class Question {
  static fromProto(proto) {
    let m = new Question();
    m = Object.assign(m, proto);
    if (proto.totalAnswerCount) {
      m.totalAnswerCount = parseInt(proto.totalAnswerCount, 10);
    }
    if (proto.upVoteCount) {
      m.upVoteCount = parseInt(proto.upVoteCount, 10);
    }
    if (proto.published) {
      m.published = new Date(proto.published);
    }
    if (proto.created) {
      m.created = new Date(proto.created);
    }
    if (proto.modified) {
      m.modified = new Date(proto.modified);
    }
    if (proto.answers) {
      m.answers = proto.answers.map(Answer.fromProto);
    }
    if (proto.previousVersions) {
      m.previousVersions = proto.previousVersions.map(Question.fromProto);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.partnerId !== 'undefined') {
      toReturn['partnerId'] = this.partnerId;
    }
    if (typeof this.accountGroupId !== 'undefined') {
      toReturn['accountGroupId'] = this.accountGroupId;
    }
    if (typeof this.locationId !== 'undefined') {
      toReturn['locationId'] = this.locationId;
    }
    if (typeof this.questionId !== 'undefined') {
      toReturn['questionId'] = this.questionId;
    }
    if (typeof this.version !== 'undefined') {
      toReturn['version'] = this.version;
    }
    if (typeof this.locationPathName !== 'undefined') {
      toReturn['locationPathName'] = this.locationPathName;
    }
    if (typeof this.text !== 'undefined') {
      toReturn['text'] = this.text;
    }
    if (typeof this.author !== 'undefined') {
      toReturn['author'] = this.author;
    }
    if (typeof this.authorPhotoUrl !== 'undefined') {
      toReturn['authorPhotoUrl'] = this.authorPhotoUrl;
    }
    if (typeof this.authorType !== 'undefined') {
      toReturn['authorType'] = this.authorType;
    }
    if (typeof this.totalAnswerCount !== 'undefined') {
      toReturn['totalAnswerCount'] = this.totalAnswerCount;
    }
    if (typeof this.upVoteCount !== 'undefined') {
      toReturn['upVoteCount'] = this.upVoteCount;
    }
    if (typeof this.published !== 'undefined' && this.published !== null) {
      toReturn['published'] = 'toApiJson' in this.published ? this.published.toApiJson() : this.published;
    }
    if (typeof this.created !== 'undefined' && this.created !== null) {
      toReturn['created'] = 'toApiJson' in this.created ? this.created.toApiJson() : this.created;
    }
    if (typeof this.modified !== 'undefined' && this.modified !== null) {
      toReturn['modified'] = 'toApiJson' in this.modified ? this.modified.toApiJson() : this.modified;
    }
    if (typeof this.answers !== 'undefined' && this.answers !== null) {
      toReturn['answers'] = 'toApiJson' in this.answers ? this.answers.toApiJson() : this.answers;
    }
    if (typeof this.previousVersions !== 'undefined' && this.previousVersions !== null) {
      toReturn['previousVersions'] = 'toApiJson' in this.previousVersions ? this.previousVersions.toApiJson() : this.previousVersions;
    }
    return toReturn;
  }
}
function enumStringToValue$3(enumRef, value) {
  if (typeof value === 'number') {
    return value;
  }
  return enumRef[value];
}
class CreateEventRequest {
  static fromProto(proto) {
    let m = new CreateEventRequest();
    m = Object.assign(m, proto);
    if (proto.eventType) {
      m.eventType = enumStringToValue$3(EventType, proto.eventType);
    }
    if (proto.user) {
      m.user = User.fromProto(proto.user);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.eventType !== 'undefined') {
      toReturn['eventType'] = this.eventType;
    }
    if (typeof this.user !== 'undefined' && this.user !== null) {
      toReturn['user'] = 'toApiJson' in this.user ? this.user.toApiJson() : this.user;
    }
    if (typeof this.gmbConversationId !== 'undefined') {
      toReturn['gmbConversationId'] = this.gmbConversationId;
    }
    return toReturn;
  }
}
class CreateEventResponse {
  static fromProto(proto) {
    let m = new CreateEventResponse();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.eventId !== 'undefined') {
      toReturn['eventId'] = this.eventId;
    }
    return toReturn;
  }
}
class Image {
  static fromProto(proto) {
    let m = new Image();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.fileUrl !== 'undefined') {
      toReturn['fileUrl'] = this.fileUrl;
    }
    return toReturn;
  }
}
class SendMessageRequest {
  static fromProto(proto) {
    let m = new SendMessageRequest();
    m = Object.assign(m, proto);
    if (proto.sender) {
      m.sender = User.fromProto(proto.sender);
    }
    if (proto.image) {
      m.image = Image.fromProto(proto.image);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.gmbConversationId !== 'undefined') {
      toReturn['gmbConversationId'] = this.gmbConversationId;
    }
    if (typeof this.sender !== 'undefined' && this.sender !== null) {
      toReturn['sender'] = 'toApiJson' in this.sender ? this.sender.toApiJson() : this.sender;
    }
    if (typeof this.image !== 'undefined' && this.image !== null) {
      toReturn['image'] = 'toApiJson' in this.image ? this.image.toApiJson() : this.image;
    }
    if (typeof this.text !== 'undefined') {
      toReturn['text'] = this.text;
    }
    return toReturn;
  }
}
class SendMessageResponse {
  static fromProto(proto) {
    let m = new SendMessageResponse();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.messageId !== 'undefined') {
      toReturn['messageId'] = this.messageId;
    }
    return toReturn;
  }
}
class User {
  static fromProto(proto) {
    let m = new User();
    m = Object.assign(m, proto);
    if (proto.userType) {
      m.userType = enumStringToValue$3(UserType, proto.userType);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.userName !== 'undefined') {
      toReturn['userName'] = this.userName;
    }
    if (typeof this.userAvatarUrl !== 'undefined') {
      toReturn['userAvatarUrl'] = this.userAvatarUrl;
    }
    if (typeof this.userType !== 'undefined') {
      toReturn['userType'] = this.userType;
    }
    return toReturn;
  }
}
function enumStringToValue$2(enumRef, value) {
  if (typeof value === 'number') {
    return value;
  }
  return enumRef[value];
}
class CanEnableBusinessCommunicationsRequest {
  static fromProto(proto) {
    let m = new CanEnableBusinessCommunicationsRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.socialProfileId !== 'undefined') {
      toReturn['socialProfileId'] = this.socialProfileId;
    }
    return toReturn;
  }
}
class CanEnableBusinessCommunicationsResponse {
  static fromProto(proto) {
    let m = new CanEnableBusinessCommunicationsResponse();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.hasRequiredAccessScopes !== 'undefined') {
      toReturn['hasRequiredAccessScopes'] = this.hasRequiredAccessScopes;
    }
    return toReturn;
  }
}
class ConnectBusinessCommunicationsRequest {
  static fromProto(proto) {
    let m = new ConnectBusinessCommunicationsRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.accountGroupId !== 'undefined') {
      toReturn['accountGroupId'] = this.accountGroupId;
    }
    if (typeof this.socialProfileId !== 'undefined') {
      toReturn['socialProfileId'] = this.socialProfileId;
    }
    if (typeof this.partnerId !== 'undefined') {
      toReturn['partnerId'] = this.partnerId;
    }
    return toReturn;
  }
}
class GetBusinessLaunchStatusRequest {
  static fromProto(proto) {
    let m = new GetBusinessLaunchStatusRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.accountGroupId !== 'undefined') {
      toReturn['accountGroupId'] = this.accountGroupId;
    }
    if (typeof this.partnerId !== 'undefined') {
      toReturn['partnerId'] = this.partnerId;
    }
    return toReturn;
  }
}
class GetBusinessLaunchStatusResponse {
  static fromProto(proto) {
    let m = new GetBusinessLaunchStatusResponse();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.isLaunched !== 'undefined') {
      toReturn['isLaunched'] = this.isLaunched;
    }
    return toReturn;
  }
}
class UnlaunchBusinessCommunicationsAgentRequest {
  static fromProto(proto) {
    let m = new UnlaunchBusinessCommunicationsAgentRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.accountGroupId !== 'undefined') {
      toReturn['accountGroupId'] = this.accountGroupId;
    }
    if (typeof this.partnerId !== 'undefined') {
      toReturn['partnerId'] = this.partnerId;
    }
    return toReturn;
  }
}
function enumStringToValue$1(enumRef, value) {
  if (typeof value === 'number') {
    return value;
  }
  return enumRef[value];
}
class CalculateInsightsByTimePeriodRequest {
  static fromProto(proto) {
    let m = new CalculateInsightsByTimePeriodRequest();
    m = Object.assign(m, proto);
    if (proto.startDate) {
      m.startDate = new Date(proto.startDate);
    }
    if (proto.endDate) {
      m.endDate = new Date(proto.endDate);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.accountGroupId !== 'undefined') {
      toReturn['accountGroupId'] = this.accountGroupId;
    }
    if (typeof this.startDate !== 'undefined' && this.startDate !== null) {
      toReturn['startDate'] = 'toApiJson' in this.startDate ? this.startDate.toApiJson() : this.startDate;
    }
    if (typeof this.endDate !== 'undefined' && this.endDate !== null) {
      toReturn['endDate'] = 'toApiJson' in this.endDate ? this.endDate.toApiJson() : this.endDate;
    }
    return toReturn;
  }
}
class CalculateInsightsByTimePeriodResponse {
  static fromProto(proto) {
    let m = new CalculateInsightsByTimePeriodResponse();
    m = Object.assign(m, proto);
    if (proto.stats) {
      m.stats = proto.stats.map(InsightsStat.fromProto);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.stats !== 'undefined' && this.stats !== null) {
      toReturn['stats'] = 'toApiJson' in this.stats ? this.stats.toApiJson() : this.stats;
    }
    return toReturn;
  }
}
class CanRespondToReviewRequest {
  static fromProto(proto) {
    let m = new CanRespondToReviewRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.reviewId !== 'undefined') {
      toReturn['reviewId'] = this.reviewId;
    }
    return toReturn;
  }
}
class CanRespondToReviewResponse {
  static fromProto(proto) {
    let m = new CanRespondToReviewResponse();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.canPublish !== 'undefined') {
      toReturn['canPublish'] = this.canPublish;
    }
    if (typeof this.addLink !== 'undefined') {
      toReturn['addLink'] = this.addLink;
    }
    if (typeof this.message !== 'undefined') {
      toReturn['message'] = this.message;
    }
    return toReturn;
  }
}
class ConnectRequest {
  static fromProto(proto) {
    let m = new ConnectRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.googleUserId !== 'undefined') {
      toReturn['googleUserId'] = this.googleUserId;
    }
    if (typeof this.locationPathName !== 'undefined') {
      toReturn['locationPathName'] = this.locationPathName;
    }
    if (typeof this.accountGroupId !== 'undefined') {
      toReturn['accountGroupId'] = this.accountGroupId;
    }
    return toReturn;
  }
}
class ConnectResponse {
  static fromProto(proto) {
    let m = new ConnectResponse();
    m = Object.assign(m, proto);
    if (proto.location) {
      m.location = Location.fromProto(proto.location);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.location !== 'undefined' && this.location !== null) {
      toReturn['location'] = 'toApiJson' in this.location ? this.location.toApiJson() : this.location;
    }
    return toReturn;
  }
}
class DisconnectRequest {
  static fromProto(proto) {
    let m = new DisconnectRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.googleUserId !== 'undefined') {
      toReturn['googleUserId'] = this.googleUserId;
    }
    if (typeof this.locationPathName !== 'undefined') {
      toReturn['locationPathName'] = this.locationPathName;
    }
    if (typeof this.accountGroupId !== 'undefined') {
      toReturn['accountGroupId'] = this.accountGroupId;
    }
    return toReturn;
  }
}
class EnableDisableSyncRequest {
  static fromProto(proto) {
    let m = new EnableDisableSyncRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.googleUserId !== 'undefined') {
      toReturn['googleUserId'] = this.googleUserId;
    }
    if (typeof this.locationPathName !== 'undefined') {
      toReturn['locationPathName'] = this.locationPathName;
    }
    if (typeof this.accountGroupId !== 'undefined') {
      toReturn['accountGroupId'] = this.accountGroupId;
    }
    if (typeof this.syncSettingFlag !== 'undefined') {
      toReturn['syncSettingFlag'] = this.syncSettingFlag;
    }
    return toReturn;
  }
}
class EnableDisableSyncResponse {
  static fromProto(proto) {
    let m = new EnableDisableSyncResponse();
    m = Object.assign(m, proto);
    if (proto.location) {
      m.location = Location.fromProto(proto.location);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.location !== 'undefined' && this.location !== null) {
      toReturn['location'] = 'toApiJson' in this.location ? this.location.toApiJson() : this.location;
    }
    return toReturn;
  }
}
class GetAsSocialServiceRequest {
  static fromProto(proto) {
    let m = new GetAsSocialServiceRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.accountGroupId !== 'undefined') {
      toReturn['accountGroupId'] = this.accountGroupId;
    }
    return toReturn;
  }
}
class GetAsSocialServiceResponse {
  static fromProto(proto) {
    let m = new GetAsSocialServiceResponse();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.serviceType !== 'undefined') {
      toReturn['serviceType'] = this.serviceType;
    }
    if (typeof this.ssid !== 'undefined') {
      toReturn['ssid'] = this.ssid;
    }
    if (typeof this.googleUserId !== 'undefined') {
      toReturn['googleUserId'] = this.googleUserId;
    }
    if (typeof this.agid !== 'undefined') {
      toReturn['agid'] = this.agid;
    }
    if (typeof this.profileUrl !== 'undefined') {
      toReturn['profileUrl'] = this.profileUrl;
    }
    if (typeof this.socialSyncFlag !== 'undefined') {
      toReturn['socialSyncFlag'] = this.socialSyncFlag;
    }
    if (typeof this.spid !== 'undefined') {
      toReturn['spid'] = this.spid;
    }
    if (typeof this.isAuthenticated !== 'undefined') {
      toReturn['isAuthenticated'] = this.isAuthenticated;
    }
    if (typeof this.name !== 'undefined') {
      toReturn['name'] = this.name;
    }
    return toReturn;
  }
}
class GetConnectionRequest {
  static fromProto(proto) {
    let m = new GetConnectionRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.accountGroupId !== 'undefined') {
      toReturn['accountGroupId'] = this.accountGroupId;
    }
    if (typeof this.googleUserId !== 'undefined') {
      toReturn['googleUserId'] = this.googleUserId;
    }
    if (typeof this.locationPathName !== 'undefined') {
      toReturn['locationPathName'] = this.locationPathName;
    }
    if (typeof this.refreshFromGoogleFlag !== 'undefined') {
      toReturn['refreshFromGoogleFlag'] = this.refreshFromGoogleFlag;
    }
    return toReturn;
  }
}
class GetConnectionResponse {
  static fromProto(proto) {
    let m = new GetConnectionResponse();
    m = Object.assign(m, proto);
    if (proto.location) {
      m.location = Location.fromProto(proto.location);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.location !== 'undefined' && this.location !== null) {
      toReturn['location'] = 'toApiJson' in this.location ? this.location.toApiJson() : this.location;
    }
    return toReturn;
  }
}
class GetConnectionsRequest {
  static fromProto(proto) {
    let m = new GetConnectionsRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.accountGroupId !== 'undefined') {
      toReturn['accountGroupId'] = this.accountGroupId;
    }
    if (typeof this.googleUserId !== 'undefined') {
      toReturn['googleUserId'] = this.googleUserId;
    }
    if (typeof this.locationPathName !== 'undefined') {
      toReturn['locationPathName'] = this.locationPathName;
    }
    if (typeof this.refreshFromGoogleFlag !== 'undefined') {
      toReturn['refreshFromGoogleFlag'] = this.refreshFromGoogleFlag;
    }
    return toReturn;
  }
}
class GetConnectionsResponse {
  static fromProto(proto) {
    let m = new GetConnectionsResponse();
    m = Object.assign(m, proto);
    if (proto.locations) {
      m.locations = proto.locations.map(Location.fromProto);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.locations !== 'undefined' && this.locations !== null) {
      toReturn['locations'] = 'toApiJson' in this.locations ? this.locations.toApiJson() : this.locations;
    }
    return toReturn;
  }
}
class GetGoogleUserRequest {
  static fromProto(proto) {
    let m = new GetGoogleUserRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.accountGroupId !== 'undefined') {
      toReturn['accountGroupId'] = this.accountGroupId;
    }
    if (typeof this.googleUserId !== 'undefined') {
      toReturn['googleUserId'] = this.googleUserId;
    }
    return toReturn;
  }
}
class GetGoogleUserResponse {
  static fromProto(proto) {
    let m = new GetGoogleUserResponse();
    m = Object.assign(m, proto);
    if (proto.user) {
      m.user = GoogleUser.fromProto(proto.user);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.user !== 'undefined' && this.user !== null) {
      toReturn['user'] = 'toApiJson' in this.user ? this.user.toApiJson() : this.user;
    }
    return toReturn;
  }
}
class GoogleUser {
  static fromProto(proto) {
    let m = new GoogleUser();
    m = Object.assign(m, proto);
    if (proto.expiryDateTime) {
      m.expiryDateTime = new Date(proto.expiryDateTime);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.socialProfileId !== 'undefined') {
      toReturn['socialProfileId'] = this.socialProfileId;
    }
    if (typeof this.userId !== 'undefined') {
      toReturn['userId'] = this.userId;
    }
    if (typeof this.socialServiceId !== 'undefined') {
      toReturn['socialServiceId'] = this.socialServiceId;
    }
    if (typeof this.name !== 'undefined') {
      toReturn['name'] = this.name;
    }
    if (typeof this.accessToken !== 'undefined') {
      toReturn['accessToken'] = this.accessToken;
    }
    if (typeof this.refreshToken !== 'undefined') {
      toReturn['refreshToken'] = this.refreshToken;
    }
    if (typeof this.isTokenBroken !== 'undefined') {
      toReturn['isTokenBroken'] = this.isTokenBroken;
    }
    if (typeof this.expiryDateTime !== 'undefined' && this.expiryDateTime !== null) {
      toReturn['expiryDateTime'] = 'toApiJson' in this.expiryDateTime ? this.expiryDateTime.toApiJson() : this.expiryDateTime;
    }
    if (typeof this.accountGroupId !== 'undefined') {
      toReturn['accountGroupId'] = this.accountGroupId;
    }
    return toReturn;
  }
}
class InsightsStat {
  static fromProto(proto) {
    let m = new InsightsStat();
    m = Object.assign(m, proto);
    if (proto.currentValue) {
      m.currentValue = parseInt(proto.currentValue, 10);
    }
    if (proto.change) {
      m.change = parseInt(proto.change, 10);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.currentValue !== 'undefined') {
      toReturn['currentValue'] = this.currentValue;
    }
    if (typeof this.change !== 'undefined') {
      toReturn['change'] = this.change;
    }
    if (typeof this.name !== 'undefined') {
      toReturn['name'] = this.name;
    }
    return toReturn;
  }
}
class Location {
  static fromProto(proto) {
    let m = new Location();
    m = Object.assign(m, proto);
    if (proto.locationSyncSucceededOn) {
      m.locationSyncSucceededOn = new Date(proto.locationSyncSucceededOn);
    }
    if (proto.openStatusSyncSucceededOn) {
      m.openStatusSyncSucceededOn = new Date(proto.openStatusSyncSucceededOn);
    }
    if (proto.syncLastAttemptedOn) {
      m.syncLastAttemptedOn = new Date(proto.syncLastAttemptedOn);
    }
    if (proto.created) {
      m.created = new Date(proto.created);
    }
    if (proto.modified) {
      m.modified = new Date(proto.modified);
    }
    if (proto.deleted) {
      m.deleted = new Date(proto.deleted);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.accountGroupId !== 'undefined') {
      toReturn['accountGroupId'] = this.accountGroupId;
    }
    if (typeof this.socialProfileId !== 'undefined') {
      toReturn['socialProfileId'] = this.socialProfileId;
    }
    if (typeof this.address !== 'undefined') {
      toReturn['address'] = this.address;
    }
    if (typeof this.displayName !== 'undefined') {
      toReturn['displayName'] = this.displayName;
    }
    if (typeof this.googleReverify !== 'undefined') {
      toReturn['googleReverify'] = this.googleReverify;
    }
    if (typeof this.googleVerified !== 'undefined') {
      toReturn['googleVerified'] = this.googleVerified;
    }
    if (typeof this.isLocalPostApiDisabled !== 'undefined') {
      toReturn['isLocalPostApiDisabled'] = this.isLocalPostApiDisabled;
    }
    if (typeof this.isMissing !== 'undefined') {
      toReturn['isMissing'] = this.isMissing;
    }
    if (typeof this.isTokenBroken !== 'undefined') {
      toReturn['isTokenBroken'] = this.isTokenBroken;
    }
    if (typeof this.isVerified !== 'undefined') {
      toReturn['isVerified'] = this.isVerified;
    }
    if (typeof this.locationPathName !== 'undefined') {
      toReturn['locationPathName'] = this.locationPathName;
    }
    if (typeof this.logoImageId !== 'undefined') {
      toReturn['logoImageId'] = this.logoImageId;
    }
    if (typeof this.mapsPlaceId !== 'undefined') {
      toReturn['mapsPlaceId'] = this.mapsPlaceId;
    }
    if (typeof this.primaryImageId !== 'undefined') {
      toReturn['primaryImageId'] = this.primaryImageId;
    }
    if (typeof this.syncSettingFlag !== 'undefined') {
      toReturn['syncSettingFlag'] = this.syncSettingFlag;
    }
    if (typeof this.cannotSyncReasons !== 'undefined') {
      toReturn['cannotSyncReasons'] = this.cannotSyncReasons;
    }
    if (typeof this.serviceAreaPlaceId !== 'undefined') {
      toReturn['serviceAreaPlaceId'] = this.serviceAreaPlaceId;
    }
    if (typeof this.locationSyncSucceededOn !== 'undefined' && this.locationSyncSucceededOn !== null) {
      toReturn['locationSyncSucceededOn'] = 'toApiJson' in this.locationSyncSucceededOn ? this.locationSyncSucceededOn.toApiJson() : this.locationSyncSucceededOn;
    }
    if (typeof this.openStatusSyncSucceededOn !== 'undefined' && this.openStatusSyncSucceededOn !== null) {
      toReturn['openStatusSyncSucceededOn'] = 'toApiJson' in this.openStatusSyncSucceededOn ? this.openStatusSyncSucceededOn.toApiJson() : this.openStatusSyncSucceededOn;
    }
    if (typeof this.syncLastAttemptedOn !== 'undefined' && this.syncLastAttemptedOn !== null) {
      toReturn['syncLastAttemptedOn'] = 'toApiJson' in this.syncLastAttemptedOn ? this.syncLastAttemptedOn.toApiJson() : this.syncLastAttemptedOn;
    }
    if (typeof this.created !== 'undefined' && this.created !== null) {
      toReturn['created'] = 'toApiJson' in this.created ? this.created.toApiJson() : this.created;
    }
    if (typeof this.modified !== 'undefined' && this.modified !== null) {
      toReturn['modified'] = 'toApiJson' in this.modified ? this.modified.toApiJson() : this.modified;
    }
    if (typeof this.deleted !== 'undefined' && this.deleted !== null) {
      toReturn['deleted'] = 'toApiJson' in this.deleted ? this.deleted.toApiJson() : this.deleted;
    }
    return toReturn;
  }
}
class QAndAAccountData {
  static fromProto(proto) {
    let m = new QAndAAccountData();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.accountGroupId !== 'undefined') {
      toReturn['accountGroupId'] = this.accountGroupId;
    }
    if (typeof this.partnerId !== 'undefined') {
      toReturn['partnerId'] = this.partnerId;
    }
    if (typeof this.socialProfileId !== 'undefined') {
      toReturn['socialProfileId'] = this.socialProfileId;
    }
    return toReturn;
  }
}
function enumStringToValue(enumRef, value) {
  if (typeof value === 'number') {
    return value;
  }
  return enumRef[value];
}
class AccountLocation {
  static fromProto(proto) {
    let m = new AccountLocation();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.accountGroupId !== 'undefined') {
      toReturn['accountGroupId'] = this.accountGroupId;
    }
    if (typeof this.googleAccountId !== 'undefined') {
      toReturn['googleAccountId'] = this.googleAccountId;
    }
    if (typeof this.googleLocationId !== 'undefined') {
      toReturn['googleLocationId'] = this.googleLocationId;
    }
    return toReturn;
  }
}
class CreateAnswerRequest {
  static fromProto(proto) {
    let m = new CreateAnswerRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.accountGroupId !== 'undefined') {
      toReturn['accountGroupId'] = this.accountGroupId;
    }
    if (typeof this.socialProfileId !== 'undefined') {
      toReturn['socialProfileId'] = this.socialProfileId;
    }
    if (typeof this.locationPathName !== 'undefined') {
      toReturn['locationPathName'] = this.locationPathName;
    }
    if (typeof this.questionId !== 'undefined') {
      toReturn['questionId'] = this.questionId;
    }
    if (typeof this.text !== 'undefined') {
      toReturn['text'] = this.text;
    }
    return toReturn;
  }
}
class CreateAnswerResponse {
  static fromProto(proto) {
    let m = new CreateAnswerResponse();
    m = Object.assign(m, proto);
    if (proto.answer) {
      m.answer = Answer.fromProto(proto.answer);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.answer !== 'undefined' && this.answer !== null) {
      toReturn['answer'] = 'toApiJson' in this.answer ? this.answer.toApiJson() : this.answer;
    }
    return toReturn;
  }
}
class CreateQuestionRequest {
  static fromProto(proto) {
    let m = new CreateQuestionRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.accountGroupId !== 'undefined') {
      toReturn['accountGroupId'] = this.accountGroupId;
    }
    if (typeof this.socialProfileId !== 'undefined') {
      toReturn['socialProfileId'] = this.socialProfileId;
    }
    if (typeof this.locationPathName !== 'undefined') {
      toReturn['locationPathName'] = this.locationPathName;
    }
    if (typeof this.text !== 'undefined') {
      toReturn['text'] = this.text;
    }
    if (typeof this.partnerId !== 'undefined') {
      toReturn['partnerId'] = this.partnerId;
    }
    return toReturn;
  }
}
class CreateQuestionResponse {
  static fromProto(proto) {
    let m = new CreateQuestionResponse();
    m = Object.assign(m, proto);
    if (proto.question) {
      m.question = Question.fromProto(proto.question);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.question !== 'undefined' && this.question !== null) {
      toReturn['question'] = 'toApiJson' in this.question ? this.question.toApiJson() : this.question;
    }
    return toReturn;
  }
}
class DeleteAccountLocationRequest {
  static fromProto(proto) {
    let m = new DeleteAccountLocationRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.accountGroupId !== 'undefined') {
      toReturn['accountGroupId'] = this.accountGroupId;
    }
    return toReturn;
  }
}
class DeletePostRequest {
  static fromProto(proto) {
    let m = new DeletePostRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.accessToken !== 'undefined') {
      toReturn['accessToken'] = this.accessToken;
    }
    if (typeof this.postId !== 'undefined') {
      toReturn['postId'] = this.postId;
    }
    return toReturn;
  }
}
class GetMultiAccountLocationRequest {
  static fromProto(proto) {
    let m = new GetMultiAccountLocationRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.accountGroupIds !== 'undefined') {
      toReturn['accountGroupIds'] = this.accountGroupIds;
    }
    return toReturn;
  }
}
class GetMultiAccountLocationResponse {
  static fromProto(proto) {
    let m = new GetMultiAccountLocationResponse();
    m = Object.assign(m, proto);
    if (proto.accountLocations) {
      m.accountLocations = proto.accountLocations.map(AccountLocation.fromProto);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.accountLocations !== 'undefined' && this.accountLocations !== null) {
      toReturn['accountLocations'] = 'toApiJson' in this.accountLocations ? this.accountLocations.toApiJson() : this.accountLocations;
    }
    return toReturn;
  }
}
class GetMultiQuestionsRequest {
  static fromProto(proto) {
    let m = new GetMultiQuestionsRequest();
    m = Object.assign(m, proto);
    if (proto.questionIds) {
      m.questionIds = proto.questionIds.map(QuestionIdentifier.fromProto);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.questionIds !== 'undefined' && this.questionIds !== null) {
      toReturn['questionIds'] = 'toApiJson' in this.questionIds ? this.questionIds.toApiJson() : this.questionIds;
    }
    if (typeof this.includeAnswers !== 'undefined') {
      toReturn['includeAnswers'] = this.includeAnswers;
    }
    return toReturn;
  }
}
class GetMultiQuestionsResponse {
  static fromProto(proto) {
    let m = new GetMultiQuestionsResponse();
    m = Object.assign(m, proto);
    if (proto.questions) {
      m.questions = proto.questions.map(Question.fromProto);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.questions !== 'undefined' && this.questions !== null) {
      toReturn['questions'] = 'toApiJson' in this.questions ? this.questions.toApiJson() : this.questions;
    }
    return toReturn;
  }
}
class GetMultiTimeRangeRequest {
  static fromProto(proto) {
    let m = new GetMultiTimeRangeRequest();
    m = Object.assign(m, proto);
    if (proto.resourceIds) {
      m.resourceIds = proto.resourceIds.map(ResourceId.fromProto);
    }
    if (proto.startTime) {
      m.startTime = new Date(proto.startTime);
    }
    if (proto.endTime) {
      m.endTime = new Date(proto.endTime);
    }
    if (proto.metricTypes) {
      m.metricTypes = proto.metricTypes.map(v => enumStringToValue(MetricType, v));
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.resourceIds !== 'undefined' && this.resourceIds !== null) {
      toReturn['resourceIds'] = 'toApiJson' in this.resourceIds ? this.resourceIds.toApiJson() : this.resourceIds;
    }
    if (typeof this.partnerId !== 'undefined') {
      toReturn['partnerId'] = this.partnerId;
    }
    if (typeof this.startTime !== 'undefined' && this.startTime !== null) {
      toReturn['startTime'] = 'toApiJson' in this.startTime ? this.startTime.toApiJson() : this.startTime;
    }
    if (typeof this.endTime !== 'undefined' && this.endTime !== null) {
      toReturn['endTime'] = 'toApiJson' in this.endTime ? this.endTime.toApiJson() : this.endTime;
    }
    if (typeof this.metricTypes !== 'undefined') {
      toReturn['metricTypes'] = this.metricTypes;
    }
    if (typeof this.delta !== 'undefined') {
      toReturn['delta'] = this.delta;
    }
    if (typeof this.total !== 'undefined') {
      toReturn['total'] = this.total;
    }
    if (typeof this.overTime !== 'undefined') {
      toReturn['overTime'] = this.overTime;
    }
    return toReturn;
  }
}
class GetMultiTimeRangeResponse {
  static fromProto(proto) {
    let m = new GetMultiTimeRangeResponse();
    m = Object.assign(m, proto);
    if (proto.resourceInsights) {
      m.resourceInsights = proto.resourceInsights.map(GetMultiTimeRangeResponseInsightsContainer.fromProto);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.resourceInsights !== 'undefined' && this.resourceInsights !== null) {
      toReturn['resourceInsights'] = 'toApiJson' in this.resourceInsights ? this.resourceInsights.toApiJson() : this.resourceInsights;
    }
    return toReturn;
  }
}
class GetQuestionAnswerStatsRequest {
  static fromProto(proto) {
    let m = new GetQuestionAnswerStatsRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.accountGroupId !== 'undefined') {
      toReturn['accountGroupId'] = this.accountGroupId;
    }
    if (typeof this.locationId !== 'undefined') {
      toReturn['locationId'] = this.locationId;
    }
    return toReturn;
  }
}
class GetQuestionAnswerStatsResponse {
  static fromProto(proto) {
    let m = new GetQuestionAnswerStatsResponse();
    m = Object.assign(m, proto);
    if (proto.unanswered) {
      m.unanswered = parseInt(proto.unanswered, 10);
    }
    if (proto.answeredByOwner) {
      m.answeredByOwner = parseInt(proto.answeredByOwner, 10);
    }
    if (proto.totalQuestions) {
      m.totalQuestions = parseInt(proto.totalQuestions, 10);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.unanswered !== 'undefined') {
      toReturn['unanswered'] = this.unanswered;
    }
    if (typeof this.answeredByOwner !== 'undefined') {
      toReturn['answeredByOwner'] = this.answeredByOwner;
    }
    if (typeof this.totalQuestions !== 'undefined') {
      toReturn['totalQuestions'] = this.totalQuestions;
    }
    return toReturn;
  }
}
class GetQuestionRequest {
  static fromProto(proto) {
    let m = new GetQuestionRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.accountGroupId !== 'undefined') {
      toReturn['accountGroupId'] = this.accountGroupId;
    }
    if (typeof this.locationId !== 'undefined') {
      toReturn['locationId'] = this.locationId;
    }
    if (typeof this.questionId !== 'undefined') {
      toReturn['questionId'] = this.questionId;
    }
    if (typeof this.includeAnswers !== 'undefined') {
      toReturn['includeAnswers'] = this.includeAnswers;
    }
    if (typeof this.onlyLatestVersion !== 'undefined') {
      toReturn['onlyLatestVersion'] = this.onlyLatestVersion;
    }
    return toReturn;
  }
}
class GetQuestionResponse {
  static fromProto(proto) {
    let m = new GetQuestionResponse();
    m = Object.assign(m, proto);
    if (proto.question) {
      m.question = Question.fromProto(proto.question);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.question !== 'undefined' && this.question !== null) {
      toReturn['question'] = 'toApiJson' in this.question ? this.question.toApiJson() : this.question;
    }
    return toReturn;
  }
}
class GetTimeRangeRequest {
  static fromProto(proto) {
    let m = new GetTimeRangeRequest();
    m = Object.assign(m, proto);
    if (proto.startTime) {
      m.startTime = new Date(proto.startTime);
    }
    if (proto.endTime) {
      m.endTime = new Date(proto.endTime);
    }
    if (proto.metricTypes) {
      m.metricTypes = proto.metricTypes.map(v => enumStringToValue(MetricType, v));
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.groupPathNodes !== 'undefined') {
      toReturn['groupPathNodes'] = this.groupPathNodes;
    }
    if (typeof this.accountGroupId !== 'undefined') {
      toReturn['accountGroupId'] = this.accountGroupId;
    }
    if (typeof this.startTime !== 'undefined' && this.startTime !== null) {
      toReturn['startTime'] = 'toApiJson' in this.startTime ? this.startTime.toApiJson() : this.startTime;
    }
    if (typeof this.endTime !== 'undefined' && this.endTime !== null) {
      toReturn['endTime'] = 'toApiJson' in this.endTime ? this.endTime.toApiJson() : this.endTime;
    }
    if (typeof this.metricTypes !== 'undefined') {
      toReturn['metricTypes'] = this.metricTypes;
    }
    return toReturn;
  }
}
class Insight {
  static fromProto(proto) {
    let m = new Insight();
    m = Object.assign(m, proto);
    if (proto.metricType) {
      m.metricType = enumStringToValue(MetricType, proto.metricType);
    }
    if (proto.totalValue) {
      m.totalValue = Metric.fromProto(proto.totalValue);
    }
    if (proto.deltaValue) {
      m.deltaValue = Metric.fromProto(proto.deltaValue);
    }
    if (proto.metrics) {
      m.metrics = proto.metrics.map(Metric.fromProto);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.metricType !== 'undefined') {
      toReturn['metricType'] = this.metricType;
    }
    if (typeof this.totalValue !== 'undefined' && this.totalValue !== null) {
      toReturn['totalValue'] = 'toApiJson' in this.totalValue ? this.totalValue.toApiJson() : this.totalValue;
    }
    if (typeof this.deltaValue !== 'undefined' && this.deltaValue !== null) {
      toReturn['deltaValue'] = 'toApiJson' in this.deltaValue ? this.deltaValue.toApiJson() : this.deltaValue;
    }
    if (typeof this.metrics !== 'undefined' && this.metrics !== null) {
      toReturn['metrics'] = 'toApiJson' in this.metrics ? this.metrics.toApiJson() : this.metrics;
    }
    return toReturn;
  }
}
class GetMultiTimeRangeResponseInsightsContainer {
  static fromProto(proto) {
    let m = new GetMultiTimeRangeResponseInsightsContainer();
    m = Object.assign(m, proto);
    if (proto.insights) {
      m.insights = InsightsResponse.fromProto(proto.insights);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.insights !== 'undefined' && this.insights !== null) {
      toReturn['insights'] = 'toApiJson' in this.insights ? this.insights.toApiJson() : this.insights;
    }
    return toReturn;
  }
}
class InsightsResponse {
  static fromProto(proto) {
    let m = new InsightsResponse();
    m = Object.assign(m, proto);
    if (proto.insights) {
      m.insights = proto.insights.map(Insight.fromProto);
    }
    if (proto.locationCount) {
      m.locationCount = parseInt(proto.locationCount, 10);
    }
    if (proto.connectedLocationCount) {
      m.connectedLocationCount = parseInt(proto.connectedLocationCount, 10);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.insights !== 'undefined' && this.insights !== null) {
      toReturn['insights'] = 'toApiJson' in this.insights ? this.insights.toApiJson() : this.insights;
    }
    if (typeof this.locationCount !== 'undefined') {
      toReturn['locationCount'] = this.locationCount;
    }
    if (typeof this.connectedLocationCount !== 'undefined') {
      toReturn['connectedLocationCount'] = this.connectedLocationCount;
    }
    return toReturn;
  }
}
class ListQuestionsRequest {
  static fromProto(proto) {
    let m = new ListQuestionsRequest();
    m = Object.assign(m, proto);
    if (proto.limit) {
      m.limit = parseInt(proto.limit, 10);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.accountGroupId !== 'undefined') {
      toReturn['accountGroupId'] = this.accountGroupId;
    }
    if (typeof this.locationId !== 'undefined') {
      toReturn['locationId'] = this.locationId;
    }
    if (typeof this.includeAnswers !== 'undefined') {
      toReturn['includeAnswers'] = this.includeAnswers;
    }
    if (typeof this.onlyLatestVersion !== 'undefined') {
      toReturn['onlyLatestVersion'] = this.onlyLatestVersion;
    }
    if (typeof this.limit !== 'undefined') {
      toReturn['limit'] = this.limit;
    }
    if (typeof this.cursor !== 'undefined') {
      toReturn['cursor'] = this.cursor;
    }
    return toReturn;
  }
}
class ListQuestionsResponse {
  static fromProto(proto) {
    let m = new ListQuestionsResponse();
    m = Object.assign(m, proto);
    if (proto.questions) {
      m.questions = proto.questions.map(Question.fromProto);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.questions !== 'undefined' && this.questions !== null) {
      toReturn['questions'] = 'toApiJson' in this.questions ? this.questions.toApiJson() : this.questions;
    }
    if (typeof this.more !== 'undefined') {
      toReturn['more'] = this.more;
    }
    if (typeof this.cursor !== 'undefined') {
      toReturn['cursor'] = this.cursor;
    }
    return toReturn;
  }
}
class Metric {
  static fromProto(proto) {
    let m = new Metric();
    m = Object.assign(m, proto);
    if (proto.value) {
      m.value = parseInt(proto.value, 10);
    }
    if (proto.timeDimension) {
      m.timeDimension = TimeDimension.fromProto(proto.timeDimension);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.value !== 'undefined') {
      toReturn['value'] = this.value;
    }
    if (typeof this.timeDimension !== 'undefined' && this.timeDimension !== null) {
      toReturn['timeDimension'] = 'toApiJson' in this.timeDimension ? this.timeDimension.toApiJson() : this.timeDimension;
    }
    return toReturn;
  }
}
class PopulateGoogleBusinessProfilePerformanceMetricsRequest {
  static fromProto(proto) {
    let m = new PopulateGoogleBusinessProfilePerformanceMetricsRequest();
    m = Object.assign(m, proto);
    if (proto.startDate) {
      m.startDate = GoogleDate.fromProto(proto.startDate);
    }
    if (proto.endDate) {
      m.endDate = GoogleDate.fromProto(proto.endDate);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.accountGroupId !== 'undefined') {
      toReturn['accountGroupId'] = this.accountGroupId;
    }
    if (typeof this.startDate !== 'undefined' && this.startDate !== null) {
      toReturn['startDate'] = 'toApiJson' in this.startDate ? this.startDate.toApiJson() : this.startDate;
    }
    if (typeof this.endDate !== 'undefined' && this.endDate !== null) {
      toReturn['endDate'] = 'toApiJson' in this.endDate ? this.endDate.toApiJson() : this.endDate;
    }
    return toReturn;
  }
}
class PopulateGoogleBusinessProfileSearchKeywordsRequest {
  static fromProto(proto) {
    let m = new PopulateGoogleBusinessProfileSearchKeywordsRequest();
    m = Object.assign(m, proto);
    if (proto.startDate) {
      m.startDate = GoogleDate.fromProto(proto.startDate);
    }
    if (proto.endDate) {
      m.endDate = GoogleDate.fromProto(proto.endDate);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.accountGroupId !== 'undefined') {
      toReturn['accountGroupId'] = this.accountGroupId;
    }
    if (typeof this.googleLocationId !== 'undefined') {
      toReturn['googleLocationId'] = this.googleLocationId;
    }
    if (typeof this.startDate !== 'undefined' && this.startDate !== null) {
      toReturn['startDate'] = 'toApiJson' in this.startDate ? this.startDate.toApiJson() : this.startDate;
    }
    if (typeof this.endDate !== 'undefined' && this.endDate !== null) {
      toReturn['endDate'] = 'toApiJson' in this.endDate ? this.endDate.toApiJson() : this.endDate;
    }
    return toReturn;
  }
}
class QuestionIdentifier {
  static fromProto(proto) {
    let m = new QuestionIdentifier();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.accountGroupId !== 'undefined') {
      toReturn['accountGroupId'] = this.accountGroupId;
    }
    if (typeof this.locationId !== 'undefined') {
      toReturn['locationId'] = this.locationId;
    }
    if (typeof this.questionId !== 'undefined') {
      toReturn['questionId'] = this.questionId;
    }
    if (typeof this.version !== 'undefined') {
      toReturn['version'] = this.version;
    }
    return toReturn;
  }
}
class ReplaceAccountLocationRequest {
  static fromProto(proto) {
    let m = new ReplaceAccountLocationRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.accountGroupId !== 'undefined') {
      toReturn['accountGroupId'] = this.accountGroupId;
    }
    if (typeof this.googleAccountId !== 'undefined') {
      toReturn['googleAccountId'] = this.googleAccountId;
    }
    if (typeof this.googleLocationId !== 'undefined') {
      toReturn['googleLocationId'] = this.googleLocationId;
    }
    return toReturn;
  }
}
class ReplacePostInsightsHistoryRequest {
  static fromProto(proto) {
    let m = new ReplacePostInsightsHistoryRequest();
    m = Object.assign(m, proto);
    if (proto.postInsightsHistory) {
      m.postInsightsHistory = PostInsightsHistory.fromProto(proto.postInsightsHistory);
    }
    if (proto.fieldMask) {
      m.fieldMask = FieldMask.fromProto(proto.fieldMask);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.postInsightsHistory !== 'undefined' && this.postInsightsHistory !== null) {
      toReturn['postInsightsHistory'] = 'toApiJson' in this.postInsightsHistory ? this.postInsightsHistory.toApiJson() : this.postInsightsHistory;
    }
    if (typeof this.fieldMask !== 'undefined' && this.fieldMask !== null) {
      toReturn['fieldMask'] = 'toApiJson' in this.fieldMask ? this.fieldMask.toApiJson() : this.fieldMask;
    }
    return toReturn;
  }
}
class ResourceId {
  static fromProto(proto) {
    let m = new ResourceId();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.groupPathNodes !== 'undefined') {
      toReturn['groupPathNodes'] = this.groupPathNodes;
    }
    if (typeof this.accountGroupId !== 'undefined') {
      toReturn['accountGroupId'] = this.accountGroupId;
    }
    return toReturn;
  }
}
class SyncDataRequest {
  static fromProto(proto) {
    let m = new SyncDataRequest();
    m = Object.assign(m, proto);
    if (proto.requestedAt) {
      m.requestedAt = new Date(proto.requestedAt);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.gmbInsightsJson !== 'undefined') {
      toReturn['gmbInsightsJson'] = this.gmbInsightsJson;
    }
    if (typeof this.requestedAt !== 'undefined' && this.requestedAt !== null) {
      toReturn['requestedAt'] = 'toApiJson' in this.requestedAt ? this.requestedAt.toApiJson() : this.requestedAt;
    }
    if (typeof this.accountGroupId !== 'undefined') {
      toReturn['accountGroupId'] = this.accountGroupId;
    }
    return toReturn;
  }
}
class TimeDimension {
  static fromProto(proto) {
    let m = new TimeDimension();
    m = Object.assign(m, proto);
    if (proto.timeRange) {
      m.timeRange = TimePeriod.fromProto(proto.timeRange);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.timeRange !== 'undefined' && this.timeRange !== null) {
      toReturn['timeRange'] = 'toApiJson' in this.timeRange ? this.timeRange.toApiJson() : this.timeRange;
    }
    return toReturn;
  }
}
class TimePeriod {
  static fromProto(proto) {
    let m = new TimePeriod();
    m = Object.assign(m, proto);
    if (proto.startTime) {
      m.startTime = new Date(proto.startTime);
    }
    if (proto.period) {
      m.period = enumStringToValue(Period, proto.period);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.startTime !== 'undefined' && this.startTime !== null) {
      toReturn['startTime'] = 'toApiJson' in this.startTime ? this.startTime.toApiJson() : this.startTime;
    }
    if (typeof this.period !== 'undefined') {
      toReturn['period'] = this.period;
    }
    return toReturn;
  }
}

// *********************************
// Code generated by sdkgen
// DO NOT EDIT!.
//
// Objects Index.
// *********************************

const environment = (window ? window['environment'] : 'prod') ?? 'prod';
const hostMap = {
  'local': 'google-my-business-api.vendasta-local.com',
  'test': '',
  'demo': 'google-my-business-api-demo.apigateway.co',
  'prod': 'google-my-business-api-prod.apigateway.co',
  'production': 'google-my-business-api-prod.apigateway.co'
};
let HostService = /*#__PURE__*/(() => {
  class HostService {
    get host() {
      return hostMap[environment.toLowerCase()];
    }
    get hostWithScheme() {
      return 'https://' + this.host;
    }
  }
  HostService.ɵfac = function HostService_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || HostService)();
  };
  HostService.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
    token: HostService,
    factory: HostService.ɵfac,
    providedIn: 'root'
  });
  return HostService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

// *********************************
// Code generated by sdkgen
// DO NOT EDIT!.
//
// API Service.
// *********************************
let AccountApiService = /*#__PURE__*/(() => {
  class AccountApiService {
    constructor(http, hostService) {
      this.http = http;
      this.hostService = hostService;
      this._host = this.hostService.hostWithScheme;
    }
    apiOptions() {
      return {
        headers: new HttpHeaders({
          'Content-Type': 'application/json'
        }),
        withCredentials: true
      };
    }
    getMultiAccountLocation(r) {
      const request = r.toApiJson ? r : new GetMultiAccountLocationRequest(r);
      return this.http.post(this._host + "/gmb.v1.Account/GetMultiAccountLocation", request.toApiJson(), this.apiOptions()).pipe(map(resp => GetMultiAccountLocationResponse.fromProto(resp)));
    }
    replaceAccountLocation(r) {
      const request = r.toApiJson ? r : new ReplaceAccountLocationRequest(r);
      return this.http.post(this._host + "/gmb.v1.Account/ReplaceAccountLocation", request.toApiJson(), {
        ...this.apiOptions(),
        observe: 'response'
      });
    }
    deleteAccountLocation(r) {
      const request = r.toApiJson ? r : new DeleteAccountLocationRequest(r);
      return this.http.post(this._host + "/gmb.v1.Account/DeleteAccountLocation", request.toApiJson(), {
        ...this.apiOptions(),
        observe: 'response'
      });
    }
    deletePost(r) {
      const request = r.toApiJson ? r : new DeletePostRequest(r);
      return this.http.post(this._host + "/gmb.v1.Account/DeletePost", request.toApiJson(), {
        ...this.apiOptions(),
        observe: 'response'
      });
    }
  }
  AccountApiService.ɵfac = function AccountApiService_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || AccountApiService)(i0.ɵɵinject(i1.HttpClient), i0.ɵɵinject(HostService));
  };
  AccountApiService.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
    token: AccountApiService,
    factory: AccountApiService.ɵfac,
    providedIn: 'root'
  });
  return AccountApiService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

// *********************************
// Code generated by sdkgen
// DO NOT EDIT!.
//
// API Service.
// *********************************
let BusinessCommunicationsApiService = /*#__PURE__*/(() => {
  class BusinessCommunicationsApiService {
    constructor(http, hostService) {
      this.http = http;
      this.hostService = hostService;
      this._host = this.hostService.hostWithScheme;
    }
    apiOptions() {
      return {
        headers: new HttpHeaders({
          'Content-Type': 'application/json'
        }),
        withCredentials: true
      };
    }
    connectBusinessCommunications(r) {
      const request = r.toApiJson ? r : new ConnectBusinessCommunicationsRequest(r);
      return this.http.post(this._host + "/gmb.v1.BusinessCommunications/ConnectBusinessCommunications", request.toApiJson(), {
        ...this.apiOptions(),
        observe: 'response'
      });
    }
    unlaunchBusinessCommunicationsAgent(r) {
      const request = r.toApiJson ? r : new UnlaunchBusinessCommunicationsAgentRequest(r);
      return this.http.post(this._host + "/gmb.v1.BusinessCommunications/UnlaunchBusinessCommunicationsAgent", request.toApiJson(), {
        ...this.apiOptions(),
        observe: 'response'
      });
    }
    getBusinessLaunchStatus(r) {
      const request = r.toApiJson ? r : new GetBusinessLaunchStatusRequest(r);
      return this.http.post(this._host + "/gmb.v1.BusinessCommunications/GetBusinessLaunchStatus", request.toApiJson(), this.apiOptions()).pipe(map(resp => GetBusinessLaunchStatusResponse.fromProto(resp)));
    }
    canEnableBusinessCommunications(r) {
      const request = r.toApiJson ? r : new CanEnableBusinessCommunicationsRequest(r);
      return this.http.post(this._host + "/gmb.v1.BusinessCommunications/CanEnableBusinessCommunications", request.toApiJson(), this.apiOptions()).pipe(map(resp => CanEnableBusinessCommunicationsResponse.fromProto(resp)));
    }
  }
  BusinessCommunicationsApiService.ɵfac = function BusinessCommunicationsApiService_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || BusinessCommunicationsApiService)(i0.ɵɵinject(i1.HttpClient), i0.ɵɵinject(HostService));
  };
  BusinessCommunicationsApiService.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
    token: BusinessCommunicationsApiService,
    factory: BusinessCommunicationsApiService.ɵfac,
    providedIn: 'root'
  });
  return BusinessCommunicationsApiService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

// *********************************
// Code generated by sdkgen
// DO NOT EDIT!.
//
// API Service.
// *********************************
let BusinessMessagesApiService = /*#__PURE__*/(() => {
  class BusinessMessagesApiService {
    constructor(http, hostService) {
      this.http = http;
      this.hostService = hostService;
      this._host = this.hostService.hostWithScheme;
    }
    apiOptions() {
      return {
        headers: new HttpHeaders({
          'Content-Type': 'application/json'
        }),
        withCredentials: true
      };
    }
    sendMessage(r) {
      const request = r.toApiJson ? r : new SendMessageRequest(r);
      return this.http.post(this._host + "/gmb.v1.BusinessMessages/SendMessage", request.toApiJson(), this.apiOptions()).pipe(map(resp => SendMessageResponse.fromProto(resp)));
    }
    createEvent(r) {
      const request = r.toApiJson ? r : new CreateEventRequest(r);
      return this.http.post(this._host + "/gmb.v1.BusinessMessages/CreateEvent", request.toApiJson(), this.apiOptions()).pipe(map(resp => CreateEventResponse.fromProto(resp)));
    }
  }
  BusinessMessagesApiService.ɵfac = function BusinessMessagesApiService_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || BusinessMessagesApiService)(i0.ɵɵinject(i1.HttpClient), i0.ɵɵinject(HostService));
  };
  BusinessMessagesApiService.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
    token: BusinessMessagesApiService,
    factory: BusinessMessagesApiService.ɵfac,
    providedIn: 'root'
  });
  return BusinessMessagesApiService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

// *********************************
// Code generated by sdkgen
// DO NOT EDIT!.
//
// API Service.
// *********************************
let GoogleMyBusinessClientLegacyAPIApiService = /*#__PURE__*/(() => {
  class GoogleMyBusinessClientLegacyAPIApiService {
    constructor(http, hostService) {
      this.http = http;
      this.hostService = hostService;
      this._host = this.hostService.hostWithScheme;
    }
    apiOptions() {
      return {
        headers: new HttpHeaders({
          'Content-Type': 'application/json'
        }),
        withCredentials: true
      };
    }
    calculateInsightsByTimePeriod(r) {
      const request = r.toApiJson ? r : new CalculateInsightsByTimePeriodRequest(r);
      return this.http.post(this._host + "/gmb.v1.GoogleMyBusinessClientLegacyAPI/CalculateInsightsByTimePeriod", request.toApiJson(), this.apiOptions()).pipe(map(resp => CalculateInsightsByTimePeriodResponse.fromProto(resp)));
    }
    canRespondToReview(r) {
      const request = r.toApiJson ? r : new CanRespondToReviewRequest(r);
      return this.http.post(this._host + "/gmb.v1.GoogleMyBusinessClientLegacyAPI/CanRespondToReview", request.toApiJson(), this.apiOptions()).pipe(map(resp => CanRespondToReviewResponse.fromProto(resp)));
    }
    connect(r) {
      const request = r.toApiJson ? r : new ConnectRequest(r);
      return this.http.post(this._host + "/gmb.v1.GoogleMyBusinessClientLegacyAPI/Connect", request.toApiJson(), this.apiOptions()).pipe(map(resp => ConnectResponse.fromProto(resp)));
    }
    disconnect(r) {
      const request = r.toApiJson ? r : new DisconnectRequest(r);
      return this.http.post(this._host + "/gmb.v1.GoogleMyBusinessClientLegacyAPI/Disconnect", request.toApiJson(), {
        ...this.apiOptions(),
        observe: 'response'
      });
    }
    enableDisableSync(r) {
      const request = r.toApiJson ? r : new EnableDisableSyncRequest(r);
      return this.http.post(this._host + "/gmb.v1.GoogleMyBusinessClientLegacyAPI/EnableDisableSync", request.toApiJson(), this.apiOptions()).pipe(map(resp => EnableDisableSyncResponse.fromProto(resp)));
    }
    getAsSocialService(r) {
      const request = r.toApiJson ? r : new GetAsSocialServiceRequest(r);
      return this.http.post(this._host + "/gmb.v1.GoogleMyBusinessClientLegacyAPI/GetAsSocialService", request.toApiJson(), this.apiOptions()).pipe(map(resp => GetAsSocialServiceResponse.fromProto(resp)));
    }
    getConnections(r) {
      const request = r.toApiJson ? r : new GetConnectionsRequest(r);
      return this.http.post(this._host + "/gmb.v1.GoogleMyBusinessClientLegacyAPI/GetConnections", request.toApiJson(), this.apiOptions()).pipe(map(resp => GetConnectionsResponse.fromProto(resp)));
    }
    getConnection(r) {
      const request = r.toApiJson ? r : new GetConnectionRequest(r);
      return this.http.post(this._host + "/gmb.v1.GoogleMyBusinessClientLegacyAPI/GetConnection", request.toApiJson(), this.apiOptions()).pipe(map(resp => GetConnectionsResponse.fromProto(resp)));
    }
    getGoogleUser(r) {
      const request = r.toApiJson ? r : new GetGoogleUserRequest(r);
      return this.http.post(this._host + "/gmb.v1.GoogleMyBusinessClientLegacyAPI/GetGoogleUser", request.toApiJson(), this.apiOptions()).pipe(map(resp => GetGoogleUserResponse.fromProto(resp)));
    }
  }
  GoogleMyBusinessClientLegacyAPIApiService.ɵfac = function GoogleMyBusinessClientLegacyAPIApiService_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || GoogleMyBusinessClientLegacyAPIApiService)(i0.ɵɵinject(i1.HttpClient), i0.ɵɵinject(HostService));
  };
  GoogleMyBusinessClientLegacyAPIApiService.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
    token: GoogleMyBusinessClientLegacyAPIApiService,
    factory: GoogleMyBusinessClientLegacyAPIApiService.ɵfac,
    providedIn: 'root'
  });
  return GoogleMyBusinessClientLegacyAPIApiService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

// *********************************
// Code generated by sdkgen
// DO NOT EDIT!.
//
// API Service.
// *********************************
let InsightsApiService = /*#__PURE__*/(() => {
  class InsightsApiService {
    constructor(http, hostService) {
      this.http = http;
      this.hostService = hostService;
      this._host = this.hostService.hostWithScheme;
    }
    apiOptions() {
      return {
        headers: new HttpHeaders({
          'Content-Type': 'application/json'
        }),
        withCredentials: true
      };
    }
    getTimeRange(r) {
      const request = r.toApiJson ? r : new GetTimeRangeRequest(r);
      return this.http.post(this._host + "/gmb.v1.Insights/GetTimeRange", request.toApiJson(), this.apiOptions()).pipe(map(resp => InsightsResponse.fromProto(resp)));
    }
    getMultiTimeRange(r) {
      const request = r.toApiJson ? r : new GetMultiTimeRangeRequest(r);
      return this.http.post(this._host + "/gmb.v1.Insights/GetMultiTimeRange", request.toApiJson(), this.apiOptions()).pipe(map(resp => GetMultiTimeRangeResponse.fromProto(resp)));
    }
    replacePostInsightsHistory(r) {
      const request = r.toApiJson ? r : new ReplacePostInsightsHistoryRequest(r);
      return this.http.post(this._host + "/gmb.v1.Insights/ReplacePostInsightsHistory", request.toApiJson(), {
        ...this.apiOptions(),
        observe: 'response'
      });
    }
  }
  InsightsApiService.ɵfac = function InsightsApiService_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || InsightsApiService)(i0.ɵɵinject(i1.HttpClient), i0.ɵɵinject(HostService));
  };
  InsightsApiService.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
    token: InsightsApiService,
    factory: InsightsApiService.ɵfac,
    providedIn: 'root'
  });
  return InsightsApiService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

// *********************************
// Code generated by sdkgen
// DO NOT EDIT!.
//
// API Service.
// *********************************
let InsightsSyncApiService = /*#__PURE__*/(() => {
  class InsightsSyncApiService {
    constructor(http, hostService) {
      this.http = http;
      this.hostService = hostService;
      this._host = this.hostService.hostWithScheme;
    }
    apiOptions() {
      return {
        headers: new HttpHeaders({
          'Content-Type': 'application/json'
        }),
        withCredentials: true
      };
    }
    syncData(r) {
      const request = r.toApiJson ? r : new SyncDataRequest(r);
      return this.http.post(this._host + "/gmb.v1.InsightsSync/SyncData", request.toApiJson(), {
        ...this.apiOptions(),
        observe: 'response'
      });
    }
    populateGoogleBusinessProfilePerformanceMetrics(r) {
      const request = r.toApiJson ? r : new PopulateGoogleBusinessProfilePerformanceMetricsRequest(r);
      return this.http.post(this._host + "/gmb.v1.InsightsSync/PopulateGoogleBusinessProfilePerformanceMetrics", request.toApiJson(), {
        ...this.apiOptions(),
        observe: 'response'
      });
    }
    populateGoogleBusinessProfileSearchKeywords(r) {
      const request = r.toApiJson ? r : new PopulateGoogleBusinessProfileSearchKeywordsRequest(r);
      return this.http.post(this._host + "/gmb.v1.InsightsSync/PopulateGoogleBusinessProfileSearchKeywords", request.toApiJson(), {
        ...this.apiOptions(),
        observe: 'response'
      });
    }
  }
  InsightsSyncApiService.ɵfac = function InsightsSyncApiService_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || InsightsSyncApiService)(i0.ɵɵinject(i1.HttpClient), i0.ɵɵinject(HostService));
  };
  InsightsSyncApiService.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
    token: InsightsSyncApiService,
    factory: InsightsSyncApiService.ɵfac,
    providedIn: 'root'
  });
  return InsightsSyncApiService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

// *********************************
// Code generated by sdkgen
// DO NOT EDIT!.
//
// API Service.
// *********************************
let QuestionAnswerApiService = /*#__PURE__*/(() => {
  class QuestionAnswerApiService {
    constructor(http, hostService) {
      this.http = http;
      this.hostService = hostService;
      this._host = this.hostService.hostWithScheme;
    }
    apiOptions() {
      return {
        headers: new HttpHeaders({
          'Content-Type': 'application/json'
        }),
        withCredentials: true
      };
    }
    listQuestions(r) {
      const request = r.toApiJson ? r : new ListQuestionsRequest(r);
      return this.http.post(this._host + "/gmb.v1.QuestionAnswer/ListQuestions", request.toApiJson(), this.apiOptions()).pipe(map(resp => ListQuestionsResponse.fromProto(resp)));
    }
    getQuestion(r) {
      const request = r.toApiJson ? r : new GetQuestionRequest(r);
      return this.http.post(this._host + "/gmb.v1.QuestionAnswer/GetQuestion", request.toApiJson(), this.apiOptions()).pipe(map(resp => GetQuestionResponse.fromProto(resp)));
    }
    getMultiQuestions(r) {
      const request = r.toApiJson ? r : new GetMultiQuestionsRequest(r);
      return this.http.post(this._host + "/gmb.v1.QuestionAnswer/GetMultiQuestions", request.toApiJson(), this.apiOptions()).pipe(map(resp => GetMultiQuestionsResponse.fromProto(resp)));
    }
    createAnswer(r) {
      const request = r.toApiJson ? r : new CreateAnswerRequest(r);
      return this.http.post(this._host + "/gmb.v1.QuestionAnswer/CreateAnswer", request.toApiJson(), this.apiOptions()).pipe(map(resp => CreateAnswerResponse.fromProto(resp)));
    }
    createQuestion(r) {
      const request = r.toApiJson ? r : new CreateQuestionRequest(r);
      return this.http.post(this._host + "/gmb.v1.QuestionAnswer/CreateQuestion", request.toApiJson(), this.apiOptions()).pipe(map(resp => CreateQuestionResponse.fromProto(resp)));
    }
    getQuestionAnswerStats(r) {
      const request = r.toApiJson ? r : new GetQuestionAnswerStatsRequest(r);
      return this.http.post(this._host + "/gmb.v1.QuestionAnswer/GetQuestionAnswerStats", request.toApiJson(), this.apiOptions()).pipe(map(resp => GetQuestionAnswerStatsResponse.fromProto(resp)));
    }
  }
  QuestionAnswerApiService.ɵfac = function QuestionAnswerApiService_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || QuestionAnswerApiService)(i0.ɵɵinject(i1.HttpClient), i0.ɵɵinject(HostService));
  };
  QuestionAnswerApiService.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
    token: QuestionAnswerApiService,
    factory: QuestionAnswerApiService.ɵfac,
    providedIn: 'root'
  });
  return QuestionAnswerApiService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

// *********************************
// Code generated by sdkgen
// DO NOT EDIT!.
//
// Index.
// *********************************
let QuestionAndAnswerService = /*#__PURE__*/(() => {
  class QuestionAndAnswerService {
    constructor(_api) {
      this._api = _api;
    }
    listQuestions(accountGroupId, cursor, includeAnswers, limit, locationId, onlyLatestVersion) {
      const request = {
        accountGroupId: accountGroupId,
        cursor: cursor,
        includeAnswers: includeAnswers,
        limit: limit,
        locationId: locationId,
        onlyLatestVersion: onlyLatestVersion
      };
      return this._api.listQuestions(request);
    }
    createAnswer(accountGroupId, socialProfileId, locationPathName, questionId, text) {
      const request = {
        accountGroupId: accountGroupId,
        socialProfileId: socialProfileId,
        locationPathName: locationPathName,
        questionId: questionId,
        text: text
      };
      return this._api.createAnswer(request);
    }
    createQuestion(partnerId, accountGroupId, socialProfileId, locationPathName, text) {
      const request = {
        accountGroupId: accountGroupId,
        socialProfileId: socialProfileId,
        locationPathName: locationPathName,
        partnerId: partnerId,
        text: text
      };
      return this._api.createQuestion(request);
    }
    getMultiQuestions(questionIds, includeAnswers) {
      const request = {
        questionIds: questionIds,
        includeAnswers: includeAnswers
      };
      return this._api.getMultiQuestions(request);
    }
    getQuestion(accountGroupId, locationId, questionId, includeAnswers, onlyLatestVersion) {
      const request = {
        accountGroupId: accountGroupId,
        locationId: locationId,
        questionId: questionId,
        includeAnswers: includeAnswers,
        onlyLatestVersion: onlyLatestVersion
      };
      return this._api.getQuestion(request);
    }
    getQuestionAnswerStats(accountGroupId, locationId) {
      const request = {
        accountGroupId: accountGroupId,
        locationId: locationId
      };
      return this._api.getQuestionAnswerStats(request);
    }
  }
  QuestionAndAnswerService.ɵfac = function QuestionAndAnswerService_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || QuestionAndAnswerService)(i0.ɵɵinject(QuestionAnswerApiService));
  };
  QuestionAndAnswerService.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
    token: QuestionAndAnswerService,
    factory: QuestionAndAnswerService.ɵfac,
    providedIn: 'root'
  });
  return QuestionAndAnswerService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/**
 * Generated bundle index. Do not edit.
 */

export { Answer, BusinessCommunicationsApiService, GetMultiQuestionsResponse, GetQuestionResponse, Question, QuestionAndAnswerService, QuestionAnswerApiService, QuestionIdentifier };
